import { useState, useEffect, useCallback } from 'react';

/**
 * Loads trained ML predictions from public/data/ml_predictions.json
 */
export default function useMlPredictions() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch(`/data/ml_predictions.json?t=${Date.now()}`);
      if (!res.ok) throw new Error('ML data not found. Run: npm run train');
      const json = await res.json();
      setData(json);
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to load ML predictions');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, loading, error, reload };
}
